// extracted by mini-css-extract-plugin
module.exports = {"main-component":"retroPoint_main-component__1PpiW"};